export const ADMIN_MACRO_USAGE_ANALYTICS_SOURCE = 'adminMacroUsage';
